import { useContext, useEffect, useState } from 'react';

import AccountPickerContext from 'contexts/AccountPickerContext';
import { DEFAULT_EXCLUDED_TAG_OPTION } from 'components/DriverAX/components/BonusRecordTagging/tagConstants';
import STORE from 'store';

// Returns the tag options available for a dataset: the hardcoded EXCLUDED
// default plus any SE-managed acceptable tags. Used by the exclusion builder
// dropdown and the runtime pill to resolve a configured tag's label/colour.
const useBonusTags = (dataType: string | undefined) => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const [tags, setTags] = useState<BonusTags.TagOption[]>([
    DEFAULT_EXCLUDED_TAG_OPTION,
  ]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!dataType) {
      setTags([DEFAULT_EXCLUDED_TAG_OPTION]);
      setIsLoading(false);
      return;
    }

    let isActive = true;
    setIsLoading(true);

    STORE.bonus
      .getBonusTagsRef({ accountId: selectedAccountId })
      .where('dataType', '==', dataType)
      .get()
      .then((snapshot) => {
        if (!isActive) return;
        const seTags: BonusTags.TagOption[] = snapshot.docs.map((doc) => {
          const t = doc.data();
          return { tag: t.tag, label: t.label, color: t.color };
        });
        setTags([DEFAULT_EXCLUDED_TAG_OPTION, ...seTags]);
        setIsLoading(false);
      })
      .catch(() => {
        if (!isActive) return;
        setTags([DEFAULT_EXCLUDED_TAG_OPTION]);
        setIsLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [dataType, selectedAccountId]);

  return { tags, isLoading };
};

export default useBonusTags;
